import { createReducer } from 'redux-starter-kit';
import { putAppConfig } from './appConfigActions';


/**
 * A selector for the app config loaded in the domain state.
 * @param {object} state The redux state of the application.
 * @returns A keyed object mapping to the application config object
 * @example const appConfig = selectAppConfigMap(state)
 */
export const selectAppConfigMaxRange = state => state.via.domain.appConfig.VIDEOS_ALLOWED_MAX_RANGE;

/**
 * A generic app config selector
 * @param {string} configCode The code the config is stored under
 */
export const selectAppConfig = (state, configCode) => state.via.domain.appConfig[configCode];

/**
 * A selector for the languages configuration state.
 * @param {object} state The redux state of the application.
 */
export const selectLanguages = (state) => {
  const langConfig = state.via.domain.appConfig.languages;
  if (!langConfig) return undefined;

  return langConfig.languages;
};

export const selectCurrencies = (state) => {
  const currencyConfig = state.via.domain.appConfig.currencies;
  if (!currencyConfig) return undefined;

  return currencyConfig.currencies;
};

export const selectBraintreeEnvironment = (state) => {
  const environmentConfig = state.via.domain.appConfig.braintreeEnvironment;
  if (!environmentConfig) return undefined;

  return environmentConfig.environment;
};

/**
 * A dict object with a property key of: applicationConfigCode and a property value of:
 * applicationConfiguration.
 * @example { code1: { applicationConfigCode: 'code1', applicationConfigDesc: 'desc1', applicationConfigValue: 'value1' },
 *            code2: { applicationConfigCode: 'code2', applicationConfigDesc: 'desc2', applicationConfigValue: 'value2' } }
 */
const initialApplicationConfiguration = {
  // applicationConfigCode: { /* application configuration object */ }
  // applicationConfigCode: { /* application configuration object */ }
  appConfig: undefined,
};

/**
 * A reducer for managing the Application Config in the domain.
 */
const appConfigReducer = createReducer(initialApplicationConfiguration, {
  // Inserts/Updates the video options
  [putAppConfig]: (state, action) => {
    const appConfig = action.payload;
    return {
      ...state,
      [appConfig.applicationConfigCode]: appConfig,
    };
  },
});

export default appConfigReducer;
